module.exports = __webpack_public_path__ + "matt-cromwell-bdf0a70c080120c2ceea7bf64fba32b9.webp";